import { DEFAULT_LAYOUT } from '@/router/constant'
import type { RouteRecordRaw } from 'vue-router'

const TransactionHistory: RouteRecordRaw = {
  path: '/TransactionHistory',
  name: 'TransactionHistory',
  component: DEFAULT_LAYOUT,
  redirect: '/TransactionHistory/indexView',

  children: [
    {
      path: 'indexView',
      name: 'TransactionHistoryIndexView',
      component: () =>
        import(
          /** webpackChunkName "initialize" */ '@/views/transactionHistory/indexView.vue'
        ),
      meta: { title: '取引履歴 ', requiresAuth: false },
    },
  ],
}

export default TransactionHistory
